import React from "react";
import { Typography, Tag, Card, Collapse } from "antd";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { useIsMobile } from "../../../hooks/useIsMobile";
import { decodeStr } from "../../../utils";

// Fix for Leaflet marker icon issue in React
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const { Text } = Typography;

const OrgOfficesMap = ({ coords }) => {
  const isMobile = useIsMobile();
  const mapHeight = isMobile ? 250 : 400;

  if (!coords || coords.length === 0) {
    const emptyContent = (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <Text type="secondary">
          Nessuna coordinata disponibile per le sedi
        </Text>
      </div>
    );

    if (isMobile) {
      return (
        <Collapse
          defaultActiveKey={[]}
          className="org-map-collapse"
          style={{ marginTop: "16px" }}
        >
          <Collapse.Panel header="Mappa Sedi" key="map">
            {emptyContent}
          </Collapse.Panel>
        </Collapse>
      );
    }

    return (
      <Card title="Mappa Sedi" style={{ marginTop: "24px" }}>
        {emptyContent}
      </Card>
    );
  }

  const avgLat =
    coords.reduce((sum, c) => sum + c.position[0], 0) / coords.length;
  const avgLng =
    coords.reduce((sum, c) => sum + c.position[1], 0) / coords.length;

  const mapContent = (
    <MapContainer
      center={[avgLat, avgLng]}
      zoom={10}
      style={{ height: mapHeight, width: "100%" }}
      scrollWheelZoom
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="&copy; OpenStreetMap contributors"
      />
      {coords.map((coord) => (
        <Marker key={coord.officeId} position={coord.position}>
          <Popup>
            <div>
              <strong>{decodeStr(coord.companyName || "")}</strong>
              <br />
              {coord.city}
              {coord.province && `, ${coord.province}`}
              <br />
              {coord.address}
              {coord.cap && ` - ${coord.cap}`}
              <br />
              <Tag
                color={coord.enabled ? "green" : "red"}
                style={{ marginTop: "8px" }}
              >
                {coord.enabled ? "Attiva" : "Non Attiva"}
              </Tag>
            </div>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );

  if (isMobile) {
    return (
      <Collapse
        defaultActiveKey={[]}
        className="org-map-collapse"
        style={{ marginTop: "16px" }}
      >
        <Collapse.Panel header={`Mappa Sedi (${coords.length})`} key="map">
          {mapContent}
        </Collapse.Panel>
      </Collapse>
    );
  }

  return (
    <Card title="Mappa Sedi">
      {mapContent}
    </Card>
  );
};

export default OrgOfficesMap;
